<template>
  <div class="dadata">
    <input
      @blur="inputOnBlur"
      @focus="inputOnFocus"
      @input="findAddress"
      v-model="search"
      class="dadata__input"
    />
    <div class="dadata__list" v-show="inputFocus && suggestionsList.length">
      <div
        @mousedown="chooseItem(item)"
        class="dadata__item"
        v-for="(item, ind) in suggestionsList"
        :key="ind"
      >
        {{ item.value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dadata",
  props: {
    token: String,
  },
  data: () => ({
    search: "",
    searchTimer: null,
    suggestionsList: [],
    inputFocus: false,
  }),
  methods: {
    inputOnFocus() {
      this.inputFocus = true;
    },
    inputOnBlur() {
      this.inputFocus = false;
    },
    chooseItem(item) {
      this.search = item.value;
      this.$emit("change", item);
      this.suggestionsList = [];
    },
    findAddress() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.$axios(
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: "Token " + this.token,
            },
            withCredentials: false,
            data: {
              query: this.search,
              count: 10,
            },
          }
        ).then((res) => {
          this.$set(this, "suggestionsList", res.data.suggestions);
        });
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.dadata {
  position: relative;

  &__input {
    width: 100%;
    height: 100%;
    border: 0;
    background-color: transparent;
    font: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__list {
    position: absolute;
    left: 0;
    top: calc(100% + 5px);
    max-height: 300px;
    background-color: #fff;
    max-width: 100%;
    width: 100%;
    overflow-y: auto;
    border: 1px solid #d2d2d2;
    z-index: 20;
  }

  &__item {
    padding: 8px 16px;
    cursor: pointer;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: #333333;
    transition: 0.3s;
    &:not(:last-child) {
      border-bottom: 1px solid #d2d2d2;
    }
    &:hover {
      background-color: #830051;
      color: #fff;
    }
  }
}
</style>